module.exports = __webpack_public_path__ + "static/media/warehouse_explorer_logo_v2.5a4f8c07.svg";